import { forwardRef, Radio as ChakraRadio, RadioProps as ChakraRadioProps } from "@chakra-ui/react";

const Radio = forwardRef<ChakraRadioProps, "input">((props, ref) => <ChakraRadio ref={ref} {...props} />);

export default Radio;
